import React from 'react'
import { injectIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'
import { MenuItem } from 'app/common/layout/menu'
import type { RootState } from 'shared/store/reducers'
import { ProfileForm } from './forms'
import { useSelector } from 'react-redux'

type Props = {
    intl: IntlShape
}

const ProfileComponent = (props: Props) => {
    const { intl } = props
    const blazonProfileImageUrl = useSelector(
        (state: RootState) =>
            state.kingdomProfilePageState.blazonProfileImageUrl
    )
    const routeDashboard = intl.formatMessage({
        id: 'routes.kingdom.dashboard'
    })
    const breadcrumb = [
        {
            link: routeDashboard,
            title: intl.formatMessage({
                id: 'kingdom.dashboard.title.breadcrumb.end'
            })
        },
        {
            title: intl.formatMessage({
                id: 'kingdom.profile.title.breadcrumb.end'
            })
        }
    ]

    return (
        <MenuItem
            breadcrumb={breadcrumb}
            url={routeDashboard}
            title={intl.formatMessage({ id: 'kingdom.profile.title' })}
            description={intl.formatMessage({
                id: 'kingdom.profile.description'
            })}
            blazonProfileImageUrl={blazonProfileImageUrl}>
            <ProfileForm />
        </MenuItem>
    )
}

const Profile = injectIntl(ProfileComponent)

export { Profile }
